import type React from 'react'
import type { IconProps } from './types'

/**
 * Snap360 Icon - Material Symbols "360"
 * Used for Snap360 (formerly PEC) module
 */
const Snap360Icon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M12 7C6.48 7 2 9.24 2 12C2 14.24 4.94 16.13 9 16.77V20L13 16L9 12V14.72C5.78 14.14 4 12.73 4 12C4 10.94 7.04 9 12 9C16.96 9 20 10.94 20 12C20 12.73 18.22 14.14 15 14.72V16.77C19.06 16.13 22 14.24 22 12C22 9.24 17.52 7 12 7Z' />
	</svg>
)

export default Snap360Icon
